import { render, staticRenderFns } from "./drawer-user-group-edit-form.vue?vue&type=template&id=eb328ad2&"
import script from "./drawer-user-group-edit-form.vue?vue&type=script&lang=js&"
export * from "./drawer-user-group-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports